import { Typography } from "@mui/material";
import React from "react";

import FavoriteSongs from "../pages/FavoriteSongs/FavoriteSongs";
import Homepage from "../pages/Home/Homepage";
import FinalScore from "../pages/Score/FinalScore";
import ScoreType from "../pages/ScoreType/ScoreType";
import Searchpage from "../pages/Search/Searchpage";
import SongScoring from "../pages/Sort/SongScoring";
import { PAGES } from "./constants";

export const getCurrentPage = (page) => {
  switch (page) {
    case PAGES.HOME:
      return <Homepage />;
    case PAGES.SEARCH:
      return <Searchpage />;
    case PAGES.SCORETYPE:
      return <ScoreType />;
    case PAGES.SORT:
      return <SongScoring />;
    case PAGES.FAVORITE:
      return <FavoriteSongs />;
    case PAGES.FINALSCORE:
      return <FinalScore />;
    default:
      return (
        <Typography variant="h1">
          Invalid Step. Please refresh the page
        </Typography>
      );
  }
};

export const handleAdd = (item, arr, arrSetter) => {
  if (arr.length === 3) {
    arrSetter((prevArr) => [...prevArr.slice(1), item]);
  } else {
    arrSetter((prevArr) => [...prevArr, item]);
  }
};

export const handleRemove = (item, arrSetter) => {
  arrSetter((prevArr) =>
    prevArr.filter((val) => val !== item)
  );
};

export const handleReplaceSpaces = (phrase) => phrase.replace(" ", "_");

export const handleReplacePeriod = (num) => {
  num = String(num)
  return num.replace(".", "point");
} 

export const handleRemovePeriod = (str) => {
  return str.replace(".", "");
} 

export const handlePlurality = (word) => word.slice(-1) === "s" ? "'" : "'s";
